import { createContext, useEffect, useReducer } from "react";
import axios from "app/utils/axios.js";
import useAuth from "app/hooks/useAuth";

const reducer = (state, action) => {
  switch (action.type) {
    case "LOAD_NOTIFICATIONS":
      return { ...state, notifications: action.payload };

    case "DELETE_NOTIFICATION":
      return {
        ...state,
        notifications: state.notifications.filter(
          (n) => n.id !== action.payload
        )
      };

    case "CLEAR_NOTIFICATIONS":
      return { ...state, notifications: [] };

    case "CREATE_NOTIFICATION":
      return {
        ...state,
        notifications: [action.payload, ...state.notifications]
      };

    default:
      return state;
  }
};

const NotificationContext = createContext({
  notifications: [],
  deleteNotification: () => {},
  clearNotifications: () => {},
  getNotifications: () => {},
  createNotification: () => {}
});

export const NotificationProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const appsCode = user?.appsCode || "TEST";
  const [state, dispatch] = useReducer(reducer, { notifications: [] }); // ✅ Fixed: Object instead of empty array

  const deleteNotification = async (notificationID) => {
    try {
      await axios.post(
        "admin/api/notifications/delete?appsCode=" + appsCode,
        { id: notificationID }
      );
      dispatch({ type: "DELETE_NOTIFICATION", payload: notificationID });
    } catch (e) {
      console.error(e);
    }
  };

  const clearNotifications = async () => {
    try {
      await axios.post(
        "admin/api/notifications/delete-all?appsCode=" + appsCode
      );
      dispatch({ type: "CLEAR_NOTIFICATIONS" });
    } catch (e) {
      console.error(e);
    }
  };

  const getNotifications = async () => {
    try {
      const res = await axios.get(
        "admin/api/notifications/fetch?appsCode=" + appsCode
      );
      dispatch({ type: "LOAD_NOTIFICATIONS", payload: res.data });
    } catch (e) {
      console.error(e);
    }
  };

  const createNotification = async (notification) => {
    console.log("createNotification called with:", notification);
    try {
      const res = await axios.post(
        "admin/api/notifications/add?appsCode=" + appsCode,
        notification
      );
      dispatch({ type: "CREATE_NOTIFICATION", payload: res.data });
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    // Only poll in-app notifications for a logged-in tenant user.
    if (isAuthenticated && user?.appsCode) {
      getNotifications();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional deps (preserve behavior)
  }, [isAuthenticated, user?.appsCode]);

  return (
    <NotificationContext.Provider
      value={{
        getNotifications,
        deleteNotification,
        clearNotifications,
        createNotification,
        notifications: state.notifications
      }}>

      {children}
    </NotificationContext.Provider>);

};

export default NotificationContext;